// Grouped picker options for the users tab's viewer-professions dropdown:
// project-active professions, ordered by sortIndex then tradeId, grouped by
// trade group. Label formula + group labels come from the shared helpers.

import type { TFunction } from 'i18next';
import type { IAdminProfession } from '@apis/adminProfessions';
import type { IGroupedOptions } from '@components/Pages/AnalyticsPage/analytics.types';
import { professionDisplayText, tradeGroupLabel } from '@utils/professionDisplay';

export function professionGroups(
  t: TFunction,
  professions: IAdminProfession[],
): IGroupedOptions[] {
  const sorted = professions
    .filter((p) => p.isActive)
    .sort((a, b) => a.sortIndex - b.sortIndex || a.tradeId.localeCompare(b.tradeId));
  const byGroup = new Map<string, IAdminProfession[]>();
  for (const profession of sorted) {
    const group = profession.tradeGroup ?? 'others';
    const bucket = byGroup.get(group);
    if (bucket) bucket.push(profession);
    else byGroup.set(group, [profession]);
  }
  return [...byGroup.entries()].map(([groupId, list]) => ({
    groupId,
    groupLabel: tradeGroupLabel(t, groupId),
    options: list.map((p) => ({ id: p._id, label: professionDisplayText(t, p) })),
  }));
}
